<div class="mb-6">
    <nz-form-label [nzSm]="6" [nzXs]="24" [nzFor]="formControl.value" [nzRequired]="this.field.props?.required">{{ to.label }}</nz-form-label>
    <div class="container">
      <div class="color-preview" [ngStyle]="{'background-color':formControl.value}"></div>
      <color-picker [readonly]="to.readonly" [control]="formControl"></color-picker>
    </div>
</div>
